import { FC } from 'react'
import { AddonSlug, PlanSlug } from 'common/planSlugs'
import {
  SmartPhone,
  SheildUser,
  CrunchSquareLogo,
  TideSquareLogo,
  ExpressEnvelope,
} from './icons'

type BusinessServiceIconType = {
  slug: AddonSlug
  size?: number
}

const BusinessServiceIcon: FC<BusinessServiceIconType> = ({ size, slug }) => {
  switch (slug) {
    case PlanSlug.SCAN_PRO:
      return (
        <ExpressEnvelope className='flex-shrink-0' height={size} width={size} />
      )
    case PlanSlug.SCAN_LITE:
      return (
        <BusinessServiceIcon className='flex-shrink-0' height={size} width={size} />
      )
    case AddonSlug.VIRTUAL_OFFICE_PHONE:
      return <SmartPhone className='flex-shrink-0' height={size} width={size} />
    case AddonSlug.DIRECTORS_SERVICE_ADDRESS:
      return <SheildUser className='flex-shrink-0' height={size} width={size} />
    case AddonSlug.CRUNCH:
      return (
        <CrunchSquareLogo
          className='flex-shrink-0'
          height={size}
          width={size}
        />
      )
    case AddonSlug.TIDE_BUSINESS_BANKING:
      return (
        <TideSquareLogo className='flex-shrink-0' height={size} width={size} />
      )
    default: {
      return null
    }
  }
}

export default BusinessServiceIcon
